var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wf-dragging-proxy",style:(_vm.cc)},[_c('div',{staticClass:"proxy-icon"},[_c('i',{staticClass:"widgeticon",class:_vm.componentName})]),_c('span',{staticClass:"proxy-name"},[_vm._v(_vm._s(_vm.componentText))])])}
var staticRenderFns = []

export { render, staticRenderFns }